import { Col, Row } from "reactstrap";
import React, { useState } from 'react';
import { SlButton, SlFormEntryRow, TextInput, SlPageTitle, SlSectionLabel } from "../editors";
import validator from "validator";
import { IdentificationType } from "./IdentificationType";
import { metadataService, LoanInfoApi, registrationService } from "../../_services";

export const MakePaymentVerifyIdentity = (props) => {

    const [loading, setLoading] = useState('');
    const [formValue, setFormValue] = useState({
        SocialSecurityNumber: '',
        DOB: '',
        IndividualTaxIdentificationNumber: '',
        identityType: '',
        useSSN: '',
        ssnItinError: true
    });

    const handleInput = ({ target: { name, value } }) => {
        let result = { ...formValue, [name]: value }
        if (name === "SocialSecurityItin") {
            if (value.SocialSecurityNumber) {
                result.SocialSecurityNumber = value.SocialSecurityNumber;
            }
            else if (value.IndividualTaxIdentificationNumber) {
                result.IndividualTaxIdentificationNumber = value.IndividualTaxIdentificationNumber;
            }

            result.ssnItinError = !value.isValid;
        }

        setFormValue(result)
    }

    const handleSubmit = async () => {
        let formError = isFormError();

        if (!formError) {
            setLoading(true);

            const userHash = await registrationService.getUserHash({
                DateOfBirth: formValue.DOB,
                SSN: formValue.SocialSecurityNumber,
            })
            const response = await LoanInfoApi.startGuestPayment(userHash.data)
            const selectedLoan = response.data.paymentInfo[0];

            var firstStep = props.STEP_SELECTLOAN;
            if (selectedLoan) {
                firstStep = props.STEP_SET_PAYINFO;
            }
            props.setParentState(response, firstStep, selectedLoan, userHash.data);
        }

        setLoading(false);
    }

    const isFormError = () => {
        return formValue.ssnItinError || validator.isEmpty(formValue.DOB);
    }

    const isIdentificationTypeValid = (fieldName, isValid) => {
        return { formError: !isValid, ssnItinError: !isValid }
    }

    return (
        <div>
            <SlPageTitle pageName="MakePayment" />
            <Row>
                <Col xs={12} md={{ size: 8, offset: 2 }}>
                    <SlSectionLabel centered={true} sectionName="ToMakeAPayment" />
                </Col>
            </Row>
            <IdentificationType
                name={"SocialSecurityItin"}
                isRequired={true}
                showLabel={true}
                onChange={handleInput}
                isValid={isIdentificationTypeValid}
                requireReEntry={true}
            />
            <SlFormEntryRow>
                <TextInput
                    name="DOB"
                    type="date"
                    label={metadataService.getFieldNameLabel("DOB")}
                    onChange={handleInput}
                    value={formValue.DOB}
                    maskOnBlur={true}
                />
            </SlFormEntryRow>
            <SlFormEntryRow>
                <div style={{ textAlign: "center" }}>

                    <SlButton 
                        onClick={handleSubmit} 
                        name={loading === true ? "Processing" : "Next"}
                        size="lg"
                        disabled={isFormError() || loading===true}
                    />

                </div>
            </SlFormEntryRow>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/subcomponents/MakePaymentVerifyIdentity.js